<script>
  export default {
    name: 'hours-card',
    data: () => ({
      closings: {
        // 2024: [
        //   { id: 1, holiday: `New Year's Day`, date: `Sunday, January 1` },
        //   { id: 2, holiday: `Martin Luther King Jr. Day`, date: `Monday, January 16` },
        //   { id: 3, holiday: `President's Day`, date: `Monday, February 20` },
        //   { id: 4, holiday: `Easter`, date: `Sunday, April 9` },
        //   { id: 5, holiday: `Memorial Day`, date: `Monday, May 29` },
        //   { id: 6, holiday: `Independence Day`, date: `Monday, July 4` },
        //   { id: 7, holiday: `Labor Day`, date: `Monday, September 4` },
        //   { id: 8, holiday: `Veteran’s Day`, date: `Monday, November 11 ` },
        //   { id: 9, holiday: `Thanksgiving Day`, date: `Thursday, November 23` },
        //   { id: 10, holiday: `Christmas Eve`, date: `Tuesday, December 24 ` },
        //   { id: 11, holiday: `Christmas Day`, date: `Wednesday, December 25 ` },
        //   { id: 12, holiday: `New Year’s Eve`, date: `Tuesday, December 31 ` }
        // ],
        2025: [
          { id: 1, holiday: `New Year's Day`, date: `Wednesday, January 1` },
          { id: 2, holiday: `Martin Luther King Jr. Day`, date: `Monday, January 20` },
          { id: 3, holiday: `President's Day`, date: `Monday, February 17` },
          { id: 4, holiday: `Easter`, date: `Sunday, April 20` },
          { id: 5, holiday: `Memorial Day`, date: `Monday, May 26` },
          { id: 6, holiday: `Independence Day`, date: `Friday, July 4` },
          { id: 7, holiday: `Labor Day`, date: `Monday, September 1` },
          { id: 8, holiday: `Veteran’s Day`, date: `Tuesday, November 11 ` },
          { id: 9, holiday: `Thanksgiving Day`, date: `Thursday, November 27` },
          { id: 10, holiday: `Christmas Eve`, date: `Wednesday, December 24 ` },
          { id: 11, holiday: `Christmas Day`, date: `Thursday, December 25 ` },
          { id: 12, holiday: `New Year’s Eve`, date: `Wednesday, December 31 ` }
        ]
      },
      hours: [
        {
          day: 'Sunday',
          hours: '1:00 PM - 5:00 PM',
          note: 'October through April'
        },
        {
          day: 'Monday',
          hours: '9:00 AM - 9:00 PM',
          note: ''
        },
        {
          day: 'Tuesday',
          hours: '9:00 AM - 9:00 PM',
          note: ''
        },
        {
          day: 'Wednesday',
          hours: '9:00 AM - 9:00 PM',
          note: ''
        },
        {
          day: 'Thursday',
          hours: '9:00 AM - 9:00 PM',
          note: ''
        },
        {
          day: 'Friday',
          hours: '9:00 AM - 6:00 PM',
          note: ''
        },
        {
          day: 'Saturday',
          hours: '9:00 AM - 5:00 PM',
          note: ''
        }
      ],
      tab: 'hours',
      today: null
    }),
    computed: {
      closingsDisplayed() {
        const currYear = new Date().getFullYear()
        const closings = {}
        for (const year in this.closings) {
          console.log(year)
          if (+year >= +currYear) {
            closings[year] = this.closings[year]
          }
        }
        return closings
      }
    },
    methods: {},
    created() {
      this.today = new Date().toLocaleDateString(undefined, { weekday: 'long' })
    }
  }
</script>

<template>
  <v-card max-width="700" width="100%" class="mt-16">
    <v-app-bar color="primary" dark>
      <v-toolbar-title class="text-h5 font-weight-bold">Library Hours & Closings</v-toolbar-title>
      <template v-slot:extension>
        <v-tabs v-model="tab">
          <v-tabs-slider color="secondary"></v-tabs-slider>

          <v-tab> Hours </v-tab>
          <v-tab> Closings </v-tab>
        </v-tabs>
      </template>
    </v-app-bar>
    <v-card-text class="card-text primary--text font-weight-bold pa-1">
      <v-tabs-items v-model="tab">
        <v-tab-item>
          <v-list two-line>
            <template v-for="hour in hours">
              <v-list-item :key="hour.day" class="px-0">
                <v-list-item-action class="mr-0">
                  <v-icon v-if="hour.day === today" color="primary" small>mdi-circle</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title class="primary--text text-body-1 font-weight-bold">{{ hour.day }}</v-list-item-title>
                  <v-list-item-subtitle class="text-body-2 font-weight-bold">{{ hour.hours }}</v-list-item-subtitle>
                  <v-list-item-subtitle>{{ hour.note ? `(${hour.note})` : '' }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-divider v-if="hour.day !== 'Saturday'" :key="hour.day + 'd'"></v-divider>
            </template>
          </v-list>
        </v-tab-item>
        <v-tab-item>
          <v-list two-line>
            <template v-for="(data, year) in closings">
              <!-- <v-divider :key="`d1-${month}`"></v-divider> -->
              <v-subheader :key="year + 'h'" v-text="year" class="year-subheader text-body-1 primary--text font-weight-bold"></v-subheader>
              <!-- <v-divider :key="`d2-${month}`"></v-divider> -->
              <v-divider :key="`d1-${year}`"></v-divider>

              <template v-for="closing in closings[year]">
                <v-list-item :key="closing.id + year" class="px-0">
                  <v-list-item-action class="mr-0"> </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title class="primary--text text-body-1 font-weight-bold">{{ closing.holiday }}</v-list-item-title>
                    <v-list-item-subtitle class="text-body-2 font-weight-bold">{{ closing.date }}</v-list-item-subtitle>
                    <v-list-item-subtitle>{{ closing.note ? `(${closing.note})` : '' }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <v-divider :key="closing.id + year + 'd'"></v-divider>
              </template>
            </template>
          </v-list>
        </v-tab-item>
      </v-tabs-items>
    </v-card-text>
  </v-card>
</template>

<style scoped>
  .card-text {
    height: 520px;
    overflow-y: auto;
  }

  .year-subheader {
    border-block: 4px solid;
    border-block-color: var(--v-primary-base);
  }
</style>
